export default {
  title: 'PayPal (direct)',
  description:
    'Verbind uw eigen PayPal-zakelijk account om PayPal-betalingen direct te ontvangen, tegen uw eigen tarief. Maak een REST-app aan in het PayPal Developer Dashboard en plak de Client ID en Secret hieronder.',
  connected_description: 'Uw PayPal-account is verbonden. Betalingen worden er direct op afgerekend.',
  guide: {
    title: 'Uw PayPal-inloggegevens ophalen',
    step1: 'Log in op het PayPal Developer Dashboard met uw PayPal-zakelijk account.',
    step2: 'Open „Apps & Credentials" en maak een app aan (of open een bestaande).',
    step3: 'Kopieer de Client ID en Secret van de app.',
    step4: 'Plak ze hieronder en klik op „PayPal verbinden".',
    environment_note:
      'Gebruik uw Live-gegevens voor echte betalingen — schakel de Sandbox/Live-schakelaar bovenaan „Apps & Credentials" om.',
    open_dashboard: 'PayPal Developer Dashboard openen',
  },
  status: {
    connected: 'Verbonden',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'Client ID van uw PayPal REST-app',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Secret van uw PayPal REST-app',
    },
  },
  buttons: {
    connect: 'PayPal verbinden',
    disconnect: 'Verbinding verbreken',
  },
  toasts: {
    connected: 'PayPal succesvol verbonden',
    connect_failed: 'PayPal kon niet worden verbonden',
    disconnected: 'PayPal losgekoppeld',
    disconnect_failed: 'PayPal kon niet worden losgekoppeld',
  },
};
